export default "__VITE_ASSET__u1hL296K__"